import { render, staticRenderFns } from "./QNewBusinessSubmenu.vue?vue&type=template&id=0d84e044&"
import script from "./QNewBusinessSubmenu.vue?vue&type=script&lang=js&"
export * from "./QNewBusinessSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports